import React from 'react'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'
import { GetCollectionWithItemsOnlyQueryResult } from 'hooks/useQueries'

import AdventureCard from '../../../../components/cards/AdventureCard'
import ListingCard from '../../../../components/cards/ListingCard'
import StoryCard from '../../../../components/cards/StoryCard'
import WithSelectEscape from '../../../../components/SelectEscape/WithSelectEscape'
import { mapGQLTypenameToGQLSearchable } from '../../../../dashboard/MyBucketlists/gql/getBucketListItemsIndexHelpers'

export type CollectionItem = GetCollectionWithItemsOnlyQueryResult['data']['collection']['items']['edges'][0]['node']['item']

type ItemProps = {
  item: CollectionItem
  bookingAdventuresIndex: GQL_BookingAdventuresIndex
  bucketListItemsIndex: GQL_BucketListItemsIndex
  photo?: Pick<GQL_PhotoImage, 'medium' | 'large'>
}

const Item = ({
  item,
  bookingAdventuresIndex,
  bucketListItemsIndex,
  photo,
}: ItemProps) => {
  const { md: largerThanMd } = useMediaQueryContext()
  const isMobile = !largerThanMd
  const itemType = mapGQLTypenameToGQLSearchable(item.__typename)

  switch (item.__typename) {
    case 'Listing':
      return (
        <>
          <WithSelectEscape
            itemId={item.id}
            itemType={itemType}
            bucketListItemsIndex={bucketListItemsIndex}
          >
            <ListingCard
              key={item.id}
              listing={item}
              asLink={isMobile}
              coverPhoto={photo}
            />
          </WithSelectEscape>
        </>
      )

    case 'Story':
      return (
        <WithSelectEscape
          itemId={item.id}
          itemType={itemType}
          bucketListItemsIndex={bucketListItemsIndex}
        >
          <StoryCard
            key={item.id}
            story={item}
            listing={item.featuredListing}
            asLink={isMobile}
            portrait={false}
            coverPhoto={photo}
          />
        </WithSelectEscape>
      )
    case 'StoryAdventure': {
      const photos = [
        ...(photo ? [{ image: photo }] : []),
        ...(item?.photos || []),
      ]

      return (
        <WithSelectEscape
          itemId={item.id}
          itemType={itemType}
          bookingAdventuresIndex={bookingAdventuresIndex}
          bucketListItemsIndex={bucketListItemsIndex}
        >
          <AdventureCard
            {...item}
            asLink={isMobile}
            showReviewScore
            photos={photos}
          />
        </WithSelectEscape>
      )
    }
    default:
      return null
  }
}

export default Item
